import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import styles from './PlanHeader.module.scss';

const COLUMN_WIDTH = 81;

const splitText = (text = '', textWidth) => {
  let tooltip;
  let showedText = text;
  const colAdjustWidth = Math.trunc(textWidth / 3);
  const textAdjustWidth = showedText ? showedText.length * 2 : 100;

  if (textAdjustWidth > colAdjustWidth) {
    showedText = text.slice(0, Math.trunc(colAdjustWidth / 3)) + '...';
    tooltip = true;
  }
  return tooltip ? (
    <Tooltip placement="top" title={text}>
      {showedText}
    </Tooltip>
  ) : (
    showedText
  );
};

export const PlanHeader = ({ tableConfig, days, t }) => (
  <div className={styles.header}>
    <div className={styles.task_header}>
      {tableConfig.map((column) => (
        <span
          key={column.label}
          className={cn(styles.columns, styles.table_column, {
            [styles.column_commited]: column.name === 'column/combine'
          })}>
          {column.data_type.includes('/icon') ||
          column.data_type.includes('/string')
            ? t('weekcommitment.columns.' + column.name + '.label')
            : splitText(
                t('weekcommitment.columns.' + column.name),
                COLUMN_WIDTH
              )}
        </span>
      ))}
    </div>
    <div className={styles.day_header}>
      {days.map((day) => (
        <span key={day} className={styles.columns}>
          {day}
        </span>
      ))}
    </div>
    <div className={styles.rfv_header}>
      <span className={cn(styles.columns, styles.completed)}>
        {t('weekcommitment.completed')}
      </span>
      <span className={cn(styles.columns, styles.rfv)}>
        {t('weekcommitment.rfv')}
      </span>
    </div>
  </div>
);

PlanHeader.propTypes = {
  tableConfig: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      data_type: PropTypes.string.isRequired
    })
  ).isRequired,
  days: PropTypes.arrayOf(PropTypes.string).isRequired,
  t: PropTypes.func.isRequired
};
